import { render, staticRenderFns } from "./Type2.vue?vue&type=template&id=1d74eacc&scoped=true"
import script from "./Type2.vue?vue&type=script&lang=js"
export * from "./Type2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d74eacc",
  null
  
)

export default component.exports